import {connect} from 'react-redux';
import React, {Component} from 'react';

import {getAllReviews} from '../../actions/Reviews';

import * as ImageUtils from '../../utils/Image';
import rateStarSVG from '../../static/img/rate-star.svg';

class Reviews extends Component {
    componentDidMount() {
        // this.props.getAllReviews();
    }

    static getStars(count) {
        let stars = [];
        for (let i = 0; i < count; i++) {
            stars.push(<img key={`stars${i}`} src={rateStarSVG} alt="" />);
        }
        return stars;
    }

    render() {
        const {i18n, allReviews, userId, firstName, lastName} = this.props;

        return (
            <div id="reviews" className="rent-reviews">
                <div className="h2-comb">
                    <h2>{i18n['objectPage.reviews']}</h2>
                    <span>{i18n['objectPage.numberOfReviews']}: {allReviews.paging.totalCount}</span>
                </div>
                <div className="rent-rev-owner">
                    <div
                        className="rent-rev-owner-ava"
                        style={{
                            backgroundImage: userId === undefined ?
                                '' :
                                `url(${ImageUtils.getUserAvatarSrc(userId)})`
                        }}
                    />
                    <div className="rent-rev-owner-info">
                        <div className="rent-rev-owner-name">
                            {firstName}&nbsp;{lastName}
                        </div>
{/*                        <a href="" className="btn">{i18n['objectPage.contactTheOwner']}</a>*/}
                    </div>
                </div>

                <a href="" className="reviews-toggle">
                    <i />
                    <span className="show">{i18n['objectPage.showReviews']}</span>
                    <span className="hide">{i18n['objectPage.hideReviews']}</span>
                </a>

                <div className="rent-reviews-box">
                    {allReviews.rows.map(review =>
                        <div key={review.id} className="rent-rev-item">
                            <div className="rent-rev-item-title">
                                <div className="rent-rev-item-rate">
                                    {Reviews.getStars(review.stars)}
                                </div>
                                <div className="rent-rev-item-name">
                                    {review.fullName}
                                </div>
                            </div>
                            <div className="rent-rev-item-content">
                                {review.content}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    allReviews: state.reviews.allReviews,
    userId: state.objectPage.currentObject.meta.userRepresent.id,
    lastName: state.objectPage.currentObject.meta.userRepresent.lastName,
    firstName: state.objectPage.currentObject.meta.userRepresent.firstName
});

const mapDispatchToProps = {
    getAllReviews
};

export default connect(mapStateToProps, mapDispatchToProps)(Reviews);



// WEBPACK FOOTER //
// ./src/components/PropertyPage/Reviews.js